import { styled } from '@stitches/react';
import { CheckIcon, ChevronDownIcon } from '@radix-ui/react-icons';
import * as SelectPrimitive from '@radix-ui/react-select';

const StyledTrigger = styled(SelectPrimitive.SelectTrigger, {
    all: 'unset',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 35px 0 29px',
    fontSize: 18,
    lineHeight: 1,
    height: 45,
    gap: 5,
    backgroundColor: 'rgba(129, 0, 190, 0.15)',
    color: '#fff',
    width: '100%',
});

const StyledContent = styled(SelectPrimitive.Content, {
    overflow: 'hidden',
    backgroundColor: 'rgba(129, 0, 190, 0.1)',
    color: '#fff',
    width: '100%',
});

const StyledViewport = styled(SelectPrimitive.Viewport, {
    padding: 5,
});

const StyledItem = styled(SelectPrimitive.Item, {
    all: 'unset',
    fontSize: 18,
    lineHeight: 1,
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    height: 35,
    padding: '0 35px 0 25px',
    position: 'relative',
    userSelect: 'none',

    '&:focus': {
        backgroundColor: 'rgba(129, 0, 190)',
        color: '#fff',
    },
});

const StyledSeparator = styled(SelectPrimitive.Separator, {
    height: 1,
    backgroundColor: 'rgba(129, 0, 190)',
    margin: 5,
});

const StyledItemIndicator = styled(SelectPrimitive.ItemIndicator, {
    position: 'absolute',
    left: 0,
    width: 25,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
});

// const scrollButtonStyles = {
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     height: 35,
//     backgroundColor: 'white',
//     color: '#000',
//     cursor: 'default',
// };

// const StyledScrollUpButton = styled(SelectPrimitive.ScrollUpButton, scrollButtonStyles);

// const StyledScrollDownButton = styled(SelectPrimitive.ScrollDownButton, scrollButtonStyles);

// Exports
export const Select = SelectPrimitive.Root;
export const SelectTrigger = StyledTrigger;
export const SelectValue = SelectPrimitive.Value;
export const SelectIcon = SelectPrimitive.Icon;
export const SelectContent = StyledContent;
export const SelectViewport = StyledViewport;
export const SelectGroup = SelectPrimitive.Group;
export const SelectItem = StyledItem;
export const SelectItemText = SelectPrimitive.ItemText;
export const SelectItemIndicator = StyledItemIndicator;
export const SelectSeparator = StyledSeparator;
// export const SelectScrollUpButton = StyledScrollUpButton;
// export const SelectScrollDownButton = StyledScrollDownButton;

// Your app...
const Box = styled('div', {});

export const GamesSelectValues = () => (
    <Box>
        <Select defaultValue="game">
            <SelectTrigger aria-label="Games">
                <SelectValue />
                <SelectIcon>
                    <ChevronDownIcon />
                </SelectIcon>
            </SelectTrigger>
            <SelectContent>
                {/* <SelectScrollUpButton>
                    <ChevronUpIcon />
                </SelectScrollUpButton> */}
                <SelectViewport>
                    <SelectGroup>
                        <SelectItem value="game">
                            <SelectItemText>Select games</SelectItemText>
                            <SelectItemIndicator>
                                <CheckIcon />
                            </SelectItemIndicator>
                        </SelectItem>
                    </SelectGroup>

                    <SelectSeparator />

                    <SelectGroup>
                        <SelectItem value="SteamMiners">
                            <SelectItemText>Steam Miners</SelectItemText>
                            <SelectItemIndicator>
                                <CheckIcon />
                            </SelectItemIndicator>
                        </SelectItem>
                        <SelectItem value="GalaxyQuest">
                            <SelectItemText>Galaxy Quest</SelectItemText>
                            <SelectItemIndicator>
                                <CheckIcon />
                            </SelectItemIndicator>
                        </SelectItem>
                        <SelectItem value="WildlifeAdventure">
                            <SelectItemText>Wildlife Adventure</SelectItemText>
                            <SelectItemIndicator>
                                <CheckIcon />
                            </SelectItemIndicator>
                        </SelectItem>
                        <SelectItem value="CashHoney">
                            <SelectItemText>Cash Honey</SelectItemText>
                            <SelectItemIndicator>
                                <CheckIcon />
                            </SelectItemIndicator>
                        </SelectItem>
                        <SelectItem value="BlackJack">
                            <SelectItemText>Black Jack</SelectItemText>
                            <SelectItemIndicator>
                                <CheckIcon />
                            </SelectItemIndicator>
                        </SelectItem>

                    </SelectGroup>

                </SelectViewport>
                {/* <SelectScrollDownButton>
                    <ChevronDownIcon />
                </SelectScrollDownButton> */}
            </SelectContent>
        </Select>
    </Box>
);

export default GamesSelectValues;

